// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-btn {
  font-family: "Inter"!important;
  font-size: 16px!important;
  font-weight: 600!important;
  margin-right: 20px!important;
  border-radius: 3px!important;
  color: #fe602f!important;
  background-color: #fff !important;
  border: 2px solid #fe602f!important;
  text-transform: capitalize!important;
}

.download-btn {
  font-family: "Inter"!important;
  font-size: 16px!important;
  font-weight: 600!important;
  border-radius: 3px!important;
  color: white!important;
  background-color: #fe602f !important;
  text-transform: capitalize!important;
}

.HeaderNameProjectSetup{
  font-family: "Inter";
font-size: 18px;
font-weight: 600;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9;
align-items: center !important;
/* justify-self: center; */

}
.dateInputforstrtDate{
  color: #8798A9 !important;
  height:44px !important;
  width:100% !important;
  /* font-size: 12px !important; */
  /* max-width: 146px !important; */
  /* border: 1px solid #8798A9 !important */
}
.dateInputforstrtDate button{
  color: #8798A9 !important;
  /* font-size: 12px !important; */
}
.dateInputforstrtDate input{
  padding: 10.5px !important;
  width: 100% !important;
  /* max-width: 100px !important; */
  color: #8798A9 !important;
  font-size: 16px !important;
}

.projectsetupSubmitButton{
  background-color: #fe602f !important;
  color:white !important;
  font-family: "Inter" !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  border-radius: 2px !important;
  width:100% !important;
  /* min-width: 146px !important; */
  height: 44px !important;
  text-align: center !important;
  align-items: center !important;
  border-radius: 4px !important;

  justify-content: center;
  border:none !important
  /* padding-top: 2%; */

}

.labelproj {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #0056B2;
  padding-left: 18px;

}

`, "",{"version":3,"sources":["webpack://./src/views/panel/reports/Reports.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb,8BAA8B;AAC9B,0BAA0B;;AAE1B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;EAChC,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;;EAE7B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;;AAEvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;;AAEpB","sourcesContent":[".reset-btn {\n  font-family: \"Inter\"!important;\n  font-size: 16px!important;\n  font-weight: 600!important;\n  margin-right: 20px!important;\n  border-radius: 3px!important;\n  color: #fe602f!important;\n  background-color: #fff !important;\n  border: 2px solid #fe602f!important;\n  text-transform: capitalize!important;\n}\n\n.download-btn {\n  font-family: \"Inter\"!important;\n  font-size: 16px!important;\n  font-weight: 600!important;\n  border-radius: 3px!important;\n  color: white!important;\n  background-color: #fe602f !important;\n  text-transform: capitalize!important;\n}\n\n.HeaderNameProjectSetup{\n  font-family: \"Inter\";\nfont-size: 18px;\nfont-weight: 600;\nline-height: 21.78px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#0070E9;\nalign-items: center !important;\n/* justify-self: center; */\n\n}\n.dateInputforstrtDate{\n  color: #8798A9 !important;\n  height:44px !important;\n  width:100% !important;\n  /* font-size: 12px !important; */\n  /* max-width: 146px !important; */\n  /* border: 1px solid #8798A9 !important */\n}\n.dateInputforstrtDate button{\n  color: #8798A9 !important;\n  /* font-size: 12px !important; */\n}\n.dateInputforstrtDate input{\n  padding: 10.5px !important;\n  width: 100% !important;\n  /* max-width: 100px !important; */\n  color: #8798A9 !important;\n  font-size: 16px !important;\n}\n\n.projectsetupSubmitButton{\n  background-color: #fe602f !important;\n  color:white !important;\n  font-family: \"Inter\" !important;\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  border-radius: 2px !important;\n  width:100% !important;\n  /* min-width: 146px !important; */\n  height: 44px !important;\n  text-align: center !important;\n  align-items: center !important;\n  border-radius: 4px !important;\n\n  justify-content: center;\n  border:none !important\n  /* padding-top: 2%; */\n\n}\n\n.labelproj {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.36px;\n  letter-spacing: 0.02em;\n  text-align: left;\n  color: #0056B2;\n  padding-left: 18px;\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
